import React from "react";
import { Link } from "react-router-dom";
import { Seo } from "@/components/Layout";
import { PageHeader, Breadcrumbs } from "@/components/Bits";
import { Target, GitCompare, Shuffle, Briefcase, MessageSquareText, CalendarClock, UserSquare, BookA, Layers, ArrowRight } from "lucide-react";

const TOOLS = [
  { slug: "prueba-de-nivel", link: "/prueba-de-nivel", icon: Target, t: "Prueba de nivel", d: "Descubre tu nivel orientativo y tu ruta." },
  { slug: "der-die-das", icon: BookA, t: "Entrenador der/die/das", d: "Practica los artículos con pistas explicadas." },
  { slug: "orden-de-palabras", icon: Shuffle, t: "Orden de palabras", d: "Coloca el verbo en su sitio y forma frases." },
  { slug: "comparador", icon: GitCompare, t: "Comparador de expresiones", d: "Estándar, forma suiza y contexto." },
  { slug: "vocabulario-profesion", icon: Briefcase, t: "Vocabulario por profesión", d: "Palabras clave de tu sector." },
  { slug: "frases", icon: MessageSquareText, t: "Frases para situaciones", d: "Frases listas para transporte, trabajo, vivienda..." },
  { slug: "plan-de-estudio", icon: CalendarClock, t: "Plan de estudio y racha", d: "Calcula tu ritmo realista." },
  { slug: "entrevista", link: "/conversaciones", icon: UserSquare, t: "Simulador de entrevista", d: "Practica una entrevista con IA." },
  { slug: "diccionario", icon: Layers, t: "Diccionario personal", d: "Guarda tus propias palabras (requiere cuenta)." },
];

export default function Tools() {
  return (
    <>
      <Seo title="Herramientas gratuitas de alemán" description="Entrenador de artículos, comparador de expresiones suizas, orden de palabras, vocabulario por profesión y más." />
      <PageHeader overline="Herramientas gratuitas" title="Practica sin registrarte"
        subtitle="Cada herramienta te da un resultado explicado, no una respuesta aislada. Los resultados personalizados no se indexan ni muestran publicidad." />
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8 py-12">
        <Breadcrumbs items={[{ label: "Inicio", to: "/" }, { label: "Herramientas" }]} />
        <div className="max-w-3xl mb-8 space-y-3 text-[15px] leading-relaxed text-muted-foreground">
          <p>Estas herramientas gratuitas te ayudan a practicar los puntos que más cuestan al aprender alemán para Suiza: el género de los sustantivos (der/die/das), el orden de las palabras en la frase, el vocabulario de tu sector profesional o las frases exactas para situaciones cotidianas. No necesitas registrarte para usarlas.</p>
          <p>Cada ejercicio te devuelve una explicación, no solo la solución, para que entiendas el porqué y lo recuerdes. Combínalas con las lecciones de la academia y con las guías prácticas para avanzar más rápido en tu día a día en Suiza.</p>
        </div>
        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-4">
          {TOOLS.map((tool) => (
            <Link key={tool.slug} to={tool.link || `/herramientas/${tool.slug}`} data-testid={`tool-${tool.slug}`}
              className="group rounded-lg border border-border bg-card p-6 hover:-translate-y-1 hover:border-primary/40 transition-transform">
              <tool.icon size={22} className="text-primary mb-4" />
              <h2 className="font-display font-semibold text-lg flex items-center justify-between">{tool.t}<ArrowRight size={16} className="opacity-0 group-hover:opacity-100 transition-opacity" /></h2>
              <p className="mt-2 text-sm text-muted-foreground leading-relaxed">{tool.d}</p>
            </Link>
          ))}
        </div>
      </div>
    </>
  );
}
